// ── watchlistCache ────────────────────────────────────────────────────────────
// The last server truth for a user's watchlist rows, kept on the device so a boot
// with no signal shows the real list instead of an empty app. IndexedDB because
// show_data blobs run to a few MB for a big library; falls back to a no-op store
// when IDB is unavailable (private mode, old WebViews) so nothing ever throws.

const DB = 'nextep', STORE = 'watchlist', VERSION = 1

function openDb() {
  return new Promise((resolve) => {
    try {
      if (typeof indexedDB === 'undefined') return resolve(null)
      const req = indexedDB.open(DB, VERSION)
      req.onupgradeneeded = () => { try { req.result.createObjectStore(STORE) } catch {} }
      req.onsuccess = () => resolve(req.result)
      req.onerror = () => resolve(null)
      req.onblocked = () => resolve(null)
    } catch { resolve(null) }
  })
}

const idbStore = {
  async get(key) {
    const db = await openDb(); if (!db) return null
    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE, 'readonly'); const req = tx.objectStore(STORE).get(key)
        req.onsuccess = () => { resolve(req.result ?? null); db.close() }
        req.onerror = () => { resolve(null); db.close() }
      } catch { resolve(null) }
    })
  },
  async set(key, value) {
    const db = await openDb(); if (!db) return
    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE, 'readwrite'); tx.objectStore(STORE).put(value, key)
        tx.oncomplete = () => { resolve(); db.close() }
        tx.onerror = () => { resolve(); db.close() }
        tx.onabort = () => { resolve(); db.close() }
      } catch { resolve() }
    })
  },
  async remove(key) {
    const db = await openDb(); if (!db) return
    return new Promise((resolve) => {
      try {
        const tx = db.transaction(STORE, 'readwrite'); tx.objectStore(STORE).delete(key)
        tx.oncomplete = () => { resolve(); db.close() }
        tx.onerror = () => { resolve(); db.close() }
      } catch { resolve() }
    })
  },
}

let store = idbStore
export function setCacheStore(s) { store = s || idbStore }

const key = (uid) => `rows:${uid}`

export async function readCachedRows(uid) {
  if (!uid) return null
  try { const v = await store.get(key(uid)); return Array.isArray(v?.rows) ? v : null } catch { return null }
}

export async function writeCachedRows(uid, rows) {
  if (!uid || !Array.isArray(rows)) return
  try { await store.set(key(uid), { rows, savedAt: Date.now() }) } catch {}
}

// Fold a successful (or queued) local change into the snapshot so the next
// no-signal boot reflects it; a missing row is left alone (adds are not cached
// until the next full load).
export async function patchCachedRow(uid, showId, patch) {
  if (!uid || !patch) return
  try {
    const cur = await readCachedRows(uid); if (!cur) return
    const id = Number(showId)
    let hit = false
    const rows = cur.rows.map(r => (Number(r.show_id) === id ? (hit = true, { ...r, ...patch }) : r))
    if (hit) await store.set(key(uid), { rows, savedAt: cur.savedAt })
  } catch {}
}

export async function clearCachedRows(uid) {
  if (!uid) return
  try { await store.remove(key(uid)) } catch {}
}
